/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../workflow/ui_elements/common';
import '../userjourney/user_journey_signal';
import '../component/component';
import '../transfer_common/transfer_native_flow';
import '../glyph/glyph_icon';
import '../../../common/currency';
import '../../../common/currency_codes';
import '../component/rich_text';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "flexible_transfer": {
                "nested": {
                  "TransferStep": {
                    "fields": {
                      "identifier": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "viewLogEvent": {
                        "type": ".squareup.bbfrontend.service.v1.LogEvent",
                        "id": 3,
                        "rule": "optional"
                      },
                      "bannerConfiguration": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.FlexibleTransferBannerConfiguration",
                        "id": 8,
                        "rule": "optional"
                      },
                      "transferOptions": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions",
                        "id": 4
                      },
                      "transferAmount": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount",
                        "id": 5
                      },
                      "transferConfirmation": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation",
                        "id": 6
                      },
                      "transferResult": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult",
                        "id": 7
                      },
                      "transfersPrimer": {
                        "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransfersPrimer",
                        "id": 9
                      }
                    },
                    "nested": {
                      "Action": {
                        "fields": {
                          "clickLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 1,
                            "rule": "optional"
                          },
                          "userJourneySignal": {
                            "type": ".squareup.bbfrontend.common.userjourney.UserJourneySignal",
                            "id": 7,
                            "rule": "optional"
                          },
                          "navigation": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Action.Navigation",
                            "id": 2
                          },
                          "clientFlow": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferClientCapableFlow",
                            "id": 3
                          },
                          "web": {
                            "type": ".squareup.bbfrontend.common.component.WebURL",
                            "id": 4
                          },
                          "step": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep",
                            "id": 5
                          },
                          "nativeFlow": {
                            "type": ".squareup.bbfrontend.common.transfer_common.TransferNativeFlow",
                            "id": 6
                          }
                        },
                        "nested": {
                          "Navigation": {
                            "values": {
                              "DO_NOT_USE_NAVIGATION": 0,
                              "NEXT": 1,
                              "FINISH": 2,
                              "FINISH_AND_REFRESH": 3
                            }
                          },
                          "action": {
                            "oneof": ["navigation", "clientFlow", "web", "step", "nativeFlow"]
                          }
                        }
                      },
                      "Button": {
                        "fields": {
                          "identifier": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "buttonDescription": {
                            "type": ".squareup.bbfrontend.common.component.ButtonDescription",
                            "id": 1,
                            "rule": "optional"
                          },
                          "action": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Action",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "TextLink": {
                        "fields": {
                          "identifier": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "linkDescription": {
                            "type": ".squareup.bbfrontend.common.component.TextLinkDescription",
                            "id": 2,
                            "rule": "optional"
                          },
                          "action": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Action",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "TransferOptions": {
                        "fields": {
                          "options": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions.Option",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "header": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "footerTextLink": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TextLink",
                            "id": 3,
                            "rule": "optional"
                          },
                          "sections": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions.Section",
                            "id": 4,
                            "rule": "repeated"
                          }
                        },
                        "nested": {
                          "Option": {
                            "fields": {
                              "identifier": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "icon": {
                                "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                                "id": 2,
                                "rule": "optional"
                              },
                              "title": {
                                "type": "string",
                                "id": 3,
                                "rule": "optional"
                              },
                              "secondaryText": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "action": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Action",
                                "id": 5,
                                "rule": "optional"
                              },
                              "inlineStatus": {
                                "type": ".squareup.bbfrontend.common.component.InlineStatusDescription",
                                "id": 6,
                                "rule": "optional"
                              }
                            }
                          },
                          "Section": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "options": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions.Option",
                                "id": 2,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      },
                      "TransferAmount": {
                        "fields": {
                          "amount": {
                            "type": ".squareup.common.Money",
                            "id": 1,
                            "rule": "optional"
                          },
                          "minAmount": {
                            "type": ".squareup.common.Money",
                            "id": 2,
                            "rule": "optional"
                          },
                          "maxAmount": {
                            "type": ".squareup.common.Money",
                            "id": 3,
                            "rule": "optional"
                          },
                          "rangeErrorMessages": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount.RangeErrorMessages",
                            "id": 4,
                            "rule": "optional"
                          },
                          "primaryFooter": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "secondaryFooter": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "primaryButton": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 7,
                            "rule": "optional"
                          },
                          "secondaryButton": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 8,
                            "rule": "optional"
                          },
                          "percentageFee": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount.PercentageFee",
                            "id": 9,
                            "rule": "optional"
                          },
                          "header": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "secondaryHeader": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "PercentageFee": {
                            "fields": {
                              "feeBasisPoints": {
                                "type": "int32",
                                "id": 1,
                                "rule": "optional"
                              },
                              "roundingMode": {
                                "type": ".squareup.common.RoundingMode",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          },
                          "RangeErrorMessages": {
                            "fields": {
                              "belowMin": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "aboveMax": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              }
                            }
                          }
                        }
                      },
                      "TransferConfirmation": {
                        "fields": {
                          "rows": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.RowItem",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "button": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 2,
                            "rule": "optional"
                          },
                          "header": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "sections": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.Section",
                            "id": 4,
                            "rule": "repeated"
                          },
                          "footer": {
                            "type": ".squareup.bbfrontend.common.component.RichText",
                            "id": 5,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "RowItem": {
                            "fields": {
                              "title": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "description": {
                                "type": "string",
                                "id": 2,
                                "rule": "optional"
                              },
                              "descriptionStyle": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.RowItem.DescriptionStyle",
                                "id": 3,
                                "rule": "optional",
                                "options": {
                                  "default": "REGULAR"
                                }
                              },
                              "secondaryDescription": {
                                "type": "string",
                                "id": 4,
                                "rule": "optional"
                              },
                              "infoBox": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.InfoBox",
                                "id": 5,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "DescriptionStyle": {
                                "values": {
                                  "REGULAR": 0,
                                  "BOLD": 1
                                }
                              }
                            }
                          },
                          "InfoBox": {
                            "fields": {
                              "text": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "style": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.InfoBox.Style",
                                "id": 2,
                                "rule": "optional",
                                "options": {
                                  "default": "STYLE_INFO"
                                }
                              }
                            },
                            "nested": {
                              "Style": {
                                "values": {
                                  "STYLE_DO_NOT_USE": 0,
                                  "STYLE_INFO": 1
                                }
                              }
                            }
                          },
                          "Section": {
                            "fields": {
                              "rows": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.RowItem",
                                "id": 1,
                                "rule": "repeated"
                              }
                            }
                          }
                        }
                      },
                      "TransferResult": {
                        "fields": {
                          "allowsBackwardNavigation": {
                            "type": "bool",
                            "id": 10,
                            "rule": "optional"
                          },
                          "icon": {
                            "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                            "id": 1,
                            "rule": "optional"
                          },
                          "iconStyle": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.IconStyle",
                            "id": 2,
                            "rule": "optional"
                          },
                          "header": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "footerText": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "buttons": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 7,
                            "rule": "repeated"
                          },
                          "toastOverlay": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.Toast",
                            "id": 9,
                            "rule": "optional"
                          },
                          "description": {
                            "type": "string",
                            "id": 4
                          },
                          "richTextDescription": {
                            "type": ".squareup.bbfrontend.common.component.RichText",
                            "id": 11
                          }
                        },
                        "nested": {
                          "IconStyle": {
                            "values": {
                              "DO_NOT_USE_ICON_STYLE": 0,
                              "EMPHASIS": 1,
                              "CRITICAL": 2,
                              "WARNING": 3
                            }
                          },
                          "Toast": {
                            "fields": {
                              "message": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "style": {
                                "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.Toast.Style",
                                "id": 2,
                                "rule": "optional"
                              }
                            },
                            "nested": {
                              "Style": {
                                "values": {
                                  "DO_NOT_USE_STYLE": 0,
                                  "SUCCESS": 1,
                                  "WARNING": 2,
                                  "CRITICAL": 3,
                                  "INFO": 4
                                }
                              }
                            }
                          },
                          "description_variant": {
                            "oneof": ["description", "richTextDescription"]
                          }
                        }
                      },
                      "TransfersPrimer": {
                        "fields": {
                          "header": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "rows": {
                            "type": ".squareup.bbfrontend.common.component.IconInfoRowDescription",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "primaryButton": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 3,
                            "rule": "optional"
                          },
                          "doNotShowAgainButton": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.Button",
                            "id": 4,
                            "rule": "optional"
                          }
                        }
                      },
                      "FlexibleTransferBannerConfiguration": {
                        "fields": {
                          "bannerDescription": {
                            "type": ".squareup.bbfrontend.common.component.BannerDescription",
                            "id": 1,
                            "rule": "optional"
                          },
                          "buttons": {
                            "type": ".squareup.bbfrontend.common.flexible_transfer.TransferStep.FlexibleTransferBannerConfiguration.Button",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "viewLogEvent": {
                            "type": ".squareup.bbfrontend.service.v1.LogEvent",
                            "id": 4,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "Button": {
                            "fields": {
                              "label": {
                                "type": "string",
                                "id": 1,
                                "rule": "optional"
                              },
                              "clickLogEvent": {
                                "type": ".squareup.bbfrontend.service.v1.LogEvent",
                                "id": 3,
                                "rule": "optional"
                              },
                              "web": {
                                "type": ".squareup.bbfrontend.common.component.WebURL",
                                "id": 2
                              }
                            },
                            "nested": {
                              "action": {
                                "oneof": ["web"]
                              }
                            }
                          }
                        }
                      },
                      "step": {
                        "oneof": ["transferOptions", "transferAmount", "transferConfirmation", "transferResult", "transfersPrimer"]
                      }
                    }
                  },
                  "TransferClientCapableFlow": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "LINK_BANK_ACCOUNT": 1,
                      "LINK_DEBIT_CARD": 2,
                      "INSTANT_TRANSFER_LINK_BANK_ACCOUNT_THEN_DEBIT_IF_NECESSARY": 3,
                      "PAPER_CASH_DEPOSIT_IN": 4,
                      "CHECK_DEPOSIT_IN": 5,
                      "TRANSFER_SETTINGS": 7,
                      "WRITE_CHECK": 8,
                      "BILL_PAY_APPLET": 9
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.Action && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.Action?.nested?.Navigation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.Button && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TextLink && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferOptions && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferOptions?.nested?.Option && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferOptions?.nested?.Section && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferAmount && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferAmount?.nested?.PercentageFee && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferAmount?.nested?.RangeErrorMessages && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation?.nested?.RowItem && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation?.nested?.RowItem?.nested?.DescriptionStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation?.nested?.InfoBox && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation?.nested?.InfoBox?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferConfirmation?.nested?.Section && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferResult && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferResult?.nested?.IconStyle && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferResult?.nested?.Toast && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransferResult?.nested?.Toast?.nested?.Style && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.TransfersPrimer && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.FlexibleTransferBannerConfiguration && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferStep?.nested?.FlexibleTransferBannerConfiguration?.nested?.Button && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.flexible_transfer?.nested?.TransferClientCapableFlow) {
  $root.addJSON(jsonData);
}

/**
 * Transfer Step
 *
 * SOURCE TransferStep @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 21:1
 */
export const TransferStep = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep');
fixType(TransferStep, {
  identifier: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep);
/**
 * SOURCE Action @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 44:3
 */
TransferStep.Action = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.Action');
fixType(TransferStep.Action);
Builder.createAndAttachToType(TransferStep.Action);
/**
 * SOURCE Navigation @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 45:5
 */
TransferStep.Action.Navigation = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferStep.Action.Navigation').values;
/**
 * SOURCE Button @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 76:3
 */
TransferStep.Button = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.Button');
fixType(TransferStep.Button, {
  identifier: {
    notEmpty: true
  },
  buttonDescription: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.Button);
/**
 * SOURCE TextLink @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 86:3
 */
TransferStep.TextLink = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TextLink');
fixType(TransferStep.TextLink, {
  identifier: {
    notEmpty: true
  },
  linkDescription: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.TextLink);
/**
 * SOURCE TransferOptions @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 94:3
 */
TransferStep.TransferOptions = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions');
fixType(TransferStep.TransferOptions, {
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferOptions);
/**
 * SOURCE Option @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 95:5
 */
TransferStep.TransferOptions.Option = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions.Option');
fixType(TransferStep.TransferOptions.Option, {
  identifier: {
    notEmpty: true
  },
  title: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferOptions.Option);
/**
 * SOURCE Section @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 110:5
 */
TransferStep.TransferOptions.Section = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferOptions.Section');
fixType(TransferStep.TransferOptions.Section);
Builder.createAndAttachToType(TransferStep.TransferOptions.Section);
/**
 * SOURCE TransferAmount @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 132:3
 */
TransferStep.TransferAmount = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount');
fixType(TransferStep.TransferAmount, {
  amount: {
    required: true
  },
  minAmount: {
    required: true
  },
  maxAmount: {
    required: true
  },
  rangeErrorMessages: {
    required: true
  },
  primaryButton: {
    required: true
  },
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferAmount);
/**
 * SOURCE PercentageFee @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 133:5
 */
TransferStep.TransferAmount.PercentageFee = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount.PercentageFee');
fixType(TransferStep.TransferAmount.PercentageFee, {
  feeBasisPoints: {
    required: true
  },
  roundingMode: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferAmount.PercentageFee);
/**
 * SOURCE RangeErrorMessages @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 140:5
 */
TransferStep.TransferAmount.RangeErrorMessages = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferAmount.RangeErrorMessages');
fixType(TransferStep.TransferAmount.RangeErrorMessages, {
  belowMin: {
    notEmpty: true
  },
  aboveMax: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferAmount.RangeErrorMessages);
/**
 * SOURCE TransferConfirmation @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 184:3
 */
TransferStep.TransferConfirmation = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation');
fixType(TransferStep.TransferConfirmation, {
  button: {
    required: true
  },
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferConfirmation);
/**
 * SOURCE RowItem @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 185:5
 */
TransferStep.TransferConfirmation.RowItem = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.RowItem');
fixType(TransferStep.TransferConfirmation.RowItem, {
  title: {
    notEmpty: true
  },
  description: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferConfirmation.RowItem);
/**
 * SOURCE DescriptionStyle @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 186:7
 */
TransferStep.TransferConfirmation.RowItem.DescriptionStyle = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.RowItem.DescriptionStyle').values;
/**
 * SOURCE InfoBox @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 207:5
 */
TransferStep.TransferConfirmation.InfoBox = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.InfoBox');
fixType(TransferStep.TransferConfirmation.InfoBox, {
  text: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferConfirmation.InfoBox);
/**
 * SOURCE Style @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 208:7
 */
TransferStep.TransferConfirmation.InfoBox.Style = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.InfoBox.Style').values;
/**
 * SOURCE Section @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 217:5
 */
TransferStep.TransferConfirmation.Section = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferConfirmation.Section');
fixType(TransferStep.TransferConfirmation.Section);
Builder.createAndAttachToType(TransferStep.TransferConfirmation.Section);
/**
 * SOURCE TransferResult @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 238:3
 */
TransferStep.TransferResult = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult');
fixType(TransferStep.TransferResult, {
  icon: {
    required: true
  },
  iconStyle: {
    required: true
  },
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferResult);
/**
 * Market color styles to be used to render the icon.
 *
 * SOURCE IconStyle @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 240:5
 */
TransferStep.TransferResult.IconStyle = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.IconStyle').values;
/**
 * SOURCE Toast @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 247:5
 */
TransferStep.TransferResult.Toast = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.Toast');
fixType(TransferStep.TransferResult.Toast, {
  message: {
    notEmpty: true
  },
  style: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.TransferResult.Toast);
/**
 * Market styles to be used to render the icon.
 *
 * SOURCE Style @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 249:7
 */
TransferStep.TransferResult.Toast.Style = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransferResult.Toast.Style').values;
/**
 * SOURCE TransfersPrimer @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 296:3
 */
TransferStep.TransfersPrimer = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.TransfersPrimer');
fixType(TransferStep.TransfersPrimer, {
  header: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransferStep.TransfersPrimer);
/**
 * Returned in the flexible transfers steps response.
 * client will use it to render the outage banner if it's present.
 *
 * SOURCE FlexibleTransferBannerConfiguration @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 309:3
 */
TransferStep.FlexibleTransferBannerConfiguration = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.FlexibleTransferBannerConfiguration');
fixType(TransferStep.FlexibleTransferBannerConfiguration, {
  bannerDescription: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.FlexibleTransferBannerConfiguration);
/**
 * SOURCE Button @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 310:5
 */
TransferStep.FlexibleTransferBannerConfiguration.Button = $root.lookupType('squareup.bbfrontend.common.flexible_transfer.TransferStep.FlexibleTransferBannerConfiguration.Button');
fixType(TransferStep.FlexibleTransferBannerConfiguration.Button, {
  label: {
    required: true
  }
});
Builder.createAndAttachToType(TransferStep.FlexibleTransferBannerConfiguration.Button);
/**
 * The client native flows that don't need bb-frontend to drive.
 *
 * SOURCE TransferClientCapableFlow @ squareup/bbfrontend/common/flexible_transfer/flexible_transfer_step.proto at 333:1
 */
export const TransferClientCapableFlow = $root.lookupEnum('squareup.bbfrontend.common.flexible_transfer.TransferClientCapableFlow').values;